import { useNamespacedNavigate, useOperations } from '@frontend/hooks';

import { OperationsName } from '../types/user';

import AccessDenied from './AccessDenied';

function getAllowedRoute(allowedPermissions: OperationsName[]) {
  if (allowedPermissions.includes('allow_chat')) {
    return '/chat';
  }
  if (allowedPermissions.includes('manage_instances')) {
    return '/instances';
  }
  if (allowedPermissions.includes('manage_instructions')) {
    return '/instructions';
  }
  return null;
}

function CanUser({ operation, children }: { operation: OperationsName; children: JSX.Element }) {
  const { operations, canUser } = useOperations();
  const navigate = useNamespacedNavigate();
  if (!canUser(operation)) {
    const allowedRoute = getAllowedRoute(operations?.filter(p => p.allowed).map(p => p.name) ?? []);
    if (allowedRoute) {
      navigate(allowedRoute);
      return null;
    }
    return <AccessDenied />;
  }

  return children;
}

export default CanUser;
